module.exports = __webpack_public_path__ + "img/top3.e46a315b.svg";